<template>
  <section class="zhzw-header header-title clear">
    <div :style="{ width: headerWidth, margin: '0 auto' }">
      <div class="header-left font-main">
        <span class="font-title1">
          <img src="static/images/logo.png" />
          {{ sysName }}
          <span v-if="childSysName" class="font-main-small child-name">{{
            childSysName
          }}</span>
        </span>
      </div>
      <div class="header-right">
        <div class="linkdiv" @click="toggleSys(myCourseMenu)">我的课堂</div>
        <el-dropdown @command="command">
          <div class="font-main-support user pointer">
            <img :src="imageUrl" v-if="imageUrl" />
            <el-avatar
              v-else
              icon="el-icon-user-solid"
              size="small"
            ></el-avatar>
            {{ userName }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="toPortal"
              ><svg-icon
                class="margin-right-5"
                :name="iconNameFormate('icon_toPortal')"
              ></svg-icon>
              前往门户</el-dropdown-item
            >
            <el-dropdown-item
              v-for="(item, index) in sysList"
              :key="index"
              @click.native="toggleSys(item)"
            >
              <svg-icon
                class="margin-right-5"
                :name="item.icon ? iconNameFormate(item.icon) : ''"
              ></svg-icon>
              {{ item.label }}
            </el-dropdown-item>
            <el-dropdown-item
              @click.native="showPassword"
              v-if="isAuth == 'false'"
              ><svg-icon
                class="margin-right-5"
                :name="iconNameFormate('icon_changePassword')"
              ></svg-icon>
              修改密码</el-dropdown-item
            >
            <el-dropdown-item command="logout"
              ><svg-icon
                class="margin-right-5"
                :name="iconNameFormate('icon_logout')"
              ></svg-icon>
              退 出
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <Password-Dialog
      :visible="passWordVisible"
      @cancel="passWordVisible = false"
      @success="changeSuccess"
    ></Password-Dialog>
  </section>
</template>

<script>
import PasswordDialog from './PasswordDialog.vue';
import { mapGetters } from 'vuex'
import string from '../../../dist/utils/string.js'
import api from "@/utils/requst.js";
export default {
  name: 'CommonHeader',
  components: {
    PasswordDialog
  },
  props: {
    headerWidth: {
      type: String,
      default: '100%'
    }
  },
  data() {
    return {
      imageUrl: null,
      filePath: '',
      sysName: window.SYS_CONFIG.SYSTEM_NAME,
      childSysName: '',
      userPortrait: '',
      userName: '',
      noticeMax: 99,
      noticeNum: 0, // 通知消息数量
      menuActive: false, // 汉堡导航展开状态
      notices: {
        read: [],
        unread: []
      },
      selection: [],
      noreadLable: '未读',
      sysList: [],
      passWordVisible: false,
      myCourseMenu: {},
      isAuth: process.env.IS_AUTH
    }
  },
  computed: {
    ...mapGetters({
      getModulesMenuShow: 'getModulesMenuShow',
      getUserInfo: 'getUserInfo',
      getSysList: 'getSysList'
    })
  },
  watch: {
    getModulesMenuShow(val) {
      this.menuActive = val
    },
    getUserInfo: {
      handler(val) {
        if (val) this.updateDetail()
      },
      deep: true
    },
    getSysList(val) {
      this.sysList = val.filter(item => item.label !== '我的课堂')
      this.myCourseMenu = val.filter(item => item.label === '我的课堂')[0] || {}
    },
  },
  mounted() {
    this.updateDetail()
    this.sysList = this.getSysList.filter(item => item.label !== '我的课堂')
    this.myCourseMenu = this.getSysList.filter(item => item.label === '我的课堂')[0] || {}
  },
  methods: {
    iconNameFormate: string.iconNameFormate,
    toggleSys(sys) {
      this.$store.state.keepAliveRoutes = []
      // 外部链接点击跳转
      if (sys.url && (!sys.children || sys.children.length === 0)) {
        window.open(sys.url)
      } else {
        // 什么路由都没有，不应该
        if (!sys.children || sys.children.length === 0) {

        } else {
          // 切换当前按钮高亮样式
          this.sysList.forEach(elem => { elem.active = false })
          sys.active = true

          if (!sys.children[0].children || sys.children[0].children.length === 0) {
            this.$router.push('/' + sys.children[0].id)
          } else if (sys.children[0].children && sys.children[0].children.some(s => (s.hideNav === false || !s.hideNav))) {
            let secondChildren = sys.children[0].children[0]
            if (secondChildren.children && secondChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
              let thirdChildren = secondChildren.children[0]
              if (thirdChildren.children && thirdChildren.children.some(s => (s.hideNav === false || !s.hideNav))) {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id + '/' + thirdChildren.children[0].id)
              } else {
                this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id + '/' + thirdChildren.id)
              }
            } else {
              this.$router.push('/' + sys.children[0].id + '/' + secondChildren.id)
            }
          } else {
            this.$router.push('/' + sys.children[0].id)
          }
          this.$store.dispatch('updateRouter', sys.children)
        }
      }
    },
    updateDetail() {
      this.userName = this.$store.getters.getUserInfo.username
      if (this.$store.getters.getUserInfo.headIconPath) this.imageUrl = this.$store.getters.getUserInfo.headIconPath

      let userInfo = this.$store.getters.getUserInfo
      if (userInfo.subserverList) {
        let item = userInfo.subserverList.find((menu) => menu.id === userInfo.currSubserverId)
        if (item) this.childSysName = item.serverName
      }
    },
    showPassword() {
      this.passWordVisible = true
    },
    changeSuccess(data) {
      this.passWordVisible = false
      window.location.href = `http://${process.env.VUE_HOST}${this.$config.baseName}?logoutRequest=true`
    },
    command(val) {
      if (val === 'logout') {
        /**
         * return_index_url：从政务工作台或信用工作台跳转到子系统中携带的来源地址
         * 判断sessionStorage中是否含有return_index_url，若存在，退出时则回到对应平台的登录页，否则默认跳转政务登录页
         */
        if (this.isAuth == 'true') {
          api.get('/xxl-sso-server/logoutByToken', {
            logout_token: sessionStorage.getItem('access_token')
          }).then(res => {
            let access_token = sessionStorage.getItem('access_token') || ''
            // 清除所有的cookie
            this.$cookies.keys().forEach(cookie => {
              this.$cookies.remove(cookie)
            })
            sessionStorage.clear()
            window.location.href = `${process.env.LOGIN_URL}/api/oauth2/logout?id_token_hint=${access_token}&post_logout_redirect_uri=${process.env.REDIRECT_URI}`
          })
        } else {
          let return_index_url = sessionStorage.getItem('return_index_url') ? unescape(sessionStorage.getItem('return_index_url')) : ''
          window.location.href = `http://${process.env.VUE_HOST}${this.$config.baseName}?logoutRequest=true` +
            (return_index_url ? `&logoutRedirectUrl=${return_index_url}` : '')
        }

      } else if (val === 'toPortal') {
        this.$router.push('/')
      }
    },
  }
}
</script>

<style lang="scss">
.zhzw-header {
  background: #fff url("../../assets/images/header_bg@2x.png") no-repeat;
  background-size: 100% 100%;
  &.header-title {
    height: 56px;
    padding: 0;
    background-color: #fff;
    overflow: hidden;
  }
  .headerbox {
    width: 1600px;
    margin: 0 auto;
  }
  .header-left {
    float: left;
    margin-top: 3px;
    > span {
      display: flex;
      align-items: center;
      font-family: ReeJi-BigRuixain;
      font-size: 32px;
      color: #0f132c;
      img {
        margin-right: 10px;
        // width: 100px;
        height: 50px;
      }
    }
    .child-name {
      margin-left: 4px;
      color: #fff;
      background: $--color-primary;
      padding: 4px 12px;
      vertical-align: top;
      border-radius: 2px;
    }
  }
  .header-right {
    float: right;
    padding-right: 20px;
    line-height: 56px;
    display: flex;
    align-items: center;
    .linkdiv {
      margin: 0 24px;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
      &:hover {
        color: $--color-primary;
      }
    }
    .item {
      margin-right: 25px;
    }
    .el-badge__content.is-fixed {
      top: 10px;
    }
    .user {
      display: flex;
      align-items: center;
      padding-left: 45px;
      margin-right: 16px;
      .el-avatar--small {
        height: 24px;
        width: 24px;
        margin-right: 12px;
      }
      img {
        height: 24px;
        width: 24px;
        border-radius: 50%;
        margin-right: 12px;
      }
    }
  }
  .el-tabs__nav-scroll {
    text-align: center;
    .el-tabs__nav {
      display: inline-block;
      float: none;
      .el-tabs__item {
        padding: 0 80px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ../vue-common-laboratory/src/components/common/CommonHeader.vue